import axios from "axios";
import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const EmailConfigurationService = {
  // Get list of email configurations
  getList: async () => {
    try {
      const response = await apiService.get("/emailconfigurations/list");
      return response.data;
    } catch (error) {
      console.error("Error fetching email configurations:", error);
      throw error;
    }
  },

  // Update an email configuration by ID
  update: async (id, data) => {
    try {
      const response = await apiService.put(
        `/emailconfigurations/${id}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error updating email configuration:", error);
      throw error;
    }
  },
};

export default EmailConfigurationService;
